import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api',
  headers: {
    'x-api-key': process.env.REACT_APP_API_KEY || '',
  },
});

export const httpRequest = async (axiosData, loaderScreen = true) => {
  const loader = document.getElementById('loader');
  if (loaderScreen && loader) loader.style.display = 'flex';
  try {
    const res = await axiosInstance.request(axiosData);
    if (loader) loader.style.display = 'none';
    return res;
  } catch (error) {
    if (loader) loader.style.display = 'none';
    console.error('[ApiV2]', error?.response?.data?.message || error?.message);
    return error;
  }
};
